var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "icon filter",
    d: "M10.587 13.859a3.194 3.194 0 1 1 3.235 3.124h-.042a3.162 3.162 0 0 1-3.193-3.124Zm1.5 0a1.7 1.7 0 1 0 1.721-1.659h-.024a1.679 1.679 0 0 0-1.699 1.659Zm-11.336.733a.733.733 0 1 1 0-1.465h6.14a.733.733 0 1 1 0 1.465H.751ZM.002 3.124a3.194 3.194 0 1 1 3.193 3.125A3.162 3.162 0 0 1 .002 3.124Zm1.5 0a1.7 1.7 0 1 0 1.721-1.659h-.024a1.679 1.679 0 0 0-1.697 1.659Zm8.587.733a.733.733 0 1 1-.05-1.465h6.19a.733.733 0 1 1 .05 1.465h-6.19Z"
  })));
};
export default SvgFilterIcon;